export const ensureTrailingSlash = (path: string) => {
  return path.replace(/\/?$/, "/");
};
